import * as styles from './MarketShareCell.module.scss';

interface Props {
  backgroundColor: string;
  ratio: number | undefined;
  value: number | undefined;
}

const MarketShareCell: React.FC<Props> = ({ backgroundColor, ratio, value }) => {
  const width = ratio === undefined ? 0 : ratio;
  return (
    <div className={styles.MarketShareCell__Container}>
      <div className={styles.MarketShareCell__Container_FullBar}>
        <div
          data-testid="market-share-cell-bar"
          className={styles.MarketShareCell__Container_Bar}
          style={{ backgroundColor, width: `${width}%` }}
        ></div>
      </div>
      <span data-testid="market-share-cell-value">{value}%</span>
    </div>
  );
};

export default MarketShareCell;
